import React from 'react';
import { useFormikContext } from 'formik';
import styled from 'styled-components';

import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import { TPostAdInitialValues } from 'src/Types';
import Input from 'src/components/Common/formik/input/TextField';

interface IStyledProps {
  isActive?: boolean;
  loading?: boolean;
  selected?: boolean;
}
const ListingSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;
const TitleWrapper = styled.div`
  margin: 24px 0 12px;
`;
const Title = styled.h1`
  font-size: 25px;
  line-height: 40px;
  font-weight: 700;
  margin: 0;
  color: ${({ theme }) => theme.colors.secondary};
`;
const StyledInput = styled(Input)`
  width: 100%;
`;
const StyledButton = styled(Button)<IStyledProps>`
  background-color: ${({ selected }) => (selected && 'rgb(44, 128, 70) !important') || 'inherit'};
`;
const ButtonGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const Label = styled.label`
  margin: 10px 0;
`;

const Details: React.FunctionComponent = () => {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    validateField,
  } = useFormikContext<TPostAdInitialValues>();
  return (
    <ListingSection>
      <TitleWrapper>
        <Title>Include some details</Title>
      </TitleWrapper>
      <StyledInput
        name="title"
        label="Ad Title*"
        placeholder="Enter Ad title"
        value={values.title}
        onBlurHandler={() => setFieldTouched('title', true)}
        onChangeHandler={(val) => setFieldValue('title', val)}
        margin="normal"
        outlined
        error={(errors?.title && touched.title) || false}
        errorText={(touched.title && errors.title) || ''}
      />
      <StyledInput
        name="description"
        label="Description*"
        placeholder="Enter short description about Ad"
        value={values.description}
        onBlurHandler={() => setFieldTouched('description', true)}
        onChangeHandler={(val) => setFieldValue('description', val)}
        margin="normal"
        rows={4}
        multiline
        outlined
        error={(errors?.description && touched.description) || false}
        errorText={(touched.description && errors.description) || ''}
      />
      <ButtonGroupContainer>
        <Label>Condition</Label>
        <ButtonGroup
          color="primary"
          aria-label="large outlined primary button group"
          variant="contained"
          size="medium"
          disableElevation
        >
          <StyledButton
            selected={values.condition === 'New'}
            onClick={() => setFieldValue('condition', 'New')}
          >
            New
          </StyledButton>
          <StyledButton
            selected={values.condition !== 'New'}
            onClick={() => setFieldValue('condition', 'Used')}
          >
            Used
          </StyledButton>
        </ButtonGroup>
      </ButtonGroupContainer>
    </ListingSection>
  );
};

export default Details;
